import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";
import { colors, type, spacing, radius } from "@/theme";

// Pagina 404 dedicata (catch-all). Nota: con una SPA statica il server restituisce
// comunque la shell HTML; qui mostriamo una 404 reale all'utente e blocchiamo l'indicizzazione.
export default function NotFound() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Pagina non trovata (404) | Tavoline";
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: colors.paper, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: spacing.xl, gap: spacing.md, textAlign: "center" }}>
      <div style={{ ...type.serif, fontSize: 72, lineHeight: "72px", color: colors.inkFaint }}>404</div>
      <div style={{ width: 72, height: 72, borderRadius: 36, background: colors.accentSoft, display: "flex", alignItems: "center", justifyContent: "center" }}><Compass size={32} color={colors.accent} /></div>
      <div style={{ ...type.serif, fontSize: 28, color: colors.ink }}>Pagina non trovata</div>
      <div style={{ ...type.sans, fontSize: 16, color: colors.inkSoft, lineHeight: "24px", maxWidth: 420 }}>L'indirizzo che hai aperto non esiste o è stato spostato.</div>
      <button data-testid="notfound-home" onClick={() => navigate("/", { replace: true })} style={{ background: colors.accent, minHeight: 52, border: "none", borderRadius: radius.md, color: colors.onAccent, ...type.sansSemi, fontSize: 16, padding: `0 ${spacing.xl}px`, marginTop: spacing.sm }}>Vai su Tavoline</button>
    </div>
  );
}
